import api from './api';

export const authService = {
  login: async (email, password) => {
    return await api.post('/auth/login', { email, password });
  },

  register: async (userData) => {
    return await api.post('/auth/register', userData);
  },

  logout: () => {
    // Token removal handled by AuthContext; no server-side session to invalidate
  },

  forgotPassword: async (email) => {
    return await api.post('/auth/forgot-password', { email });
  },

  getCurrentUser: async () => {
    return await api.get('/auth/me');
  },

  changePassword: async (currentPassword, newPassword) => {
    return await api.put('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
  },
};